import { useState } from 'react';
import { Chip, Tooltip, Typography } from '@mui/material';
import PreviewDocsModal from '../../../shared_elements/components/PreviewDocsModal';

// Normalizes the API attachment shape to the shape PreviewDocsModal expects.
const toPreviewShape = (item) => ({
    name: item?.file_name,
    url: item?.download_url,
    extension: item?.file_name?.split('.').pop().toLowerCase(),
});

const UtilsAttachments = ({ data, label, handleItemClicked }) => {
    const [previewDoc, setPreviewDoc] = useState(null);

    return (
        <div style={{ marginBottom: '15px' }}>
            {label ? (
                <Typography variant="subtitle2" sx={{ mb: '5px', fontWeight: 600 }}>
                    {label}
                </Typography>
            ) : null}
            <ul className="list-inline" style={{ paddingLeft: '14px' }}>
                {data?.map((item, index) => (
                    <li key={item?.slug || index} className="list-inline-item">
                        <Tooltip title={item?.file_name} arrow placement="top" style={{ marginTop: '3px', marginRight:"5px" }}>
                            <Chip
                                variant="outlined"
                                size="small"
                                label={item?.file_name?.length > 24 ? `${item.file_name.substring(0, 24)}...` : item?.file_name}
                                clickable
                                color="primary"
                                onClick={() => { setPreviewDoc(toPreviewShape(item)); handleItemClicked?.('Attachment Chip - UtilsAttachments') }}
                            />
                        </Tooltip>
                    </li>
                ))}
            </ul>
            {previewDoc ? (
                <PreviewDocsModal previewDocs={previewDoc} toggleModalFn={() => setPreviewDoc(null)} />
            ) : null}
        </div>
    );
};

export default UtilsAttachments;
